document.addEventListener("DOMContentLoaded", function () {
	function handleScrollToTarget(e) {
		const href = this.getAttribute("href");
		const targetSection = document.querySelector(href);

		let offsetFix = -20;
		let offsetTop = offsetFix;

		const customOffset = parseInt(this.getAttribute("data-scroll-offset"));

		if (customOffset && 0 !== customOffset) {
			offsetFix = customOffset;
		}

		if (targetSection) {
			const elementOffsetTop = document.querySelector(href).offsetTop;
			offsetTop = elementOffsetTop + 1 * offsetFix;
		}

		scroll({
			top: offsetTop,
			behavior: "smooth",
		});

		history.pushState(null, null, href);
		e.preventDefault();
	}

	const links = document.querySelectorAll(".scrollto");

	if (links.length > 0) {
		for (const link of links) {
			link.addEventListener("click", handleScrollToTarget);
		}
	}
});
